
import React from 'react';
import { Input } from '../../../../components/ui/input';
import { FieldType } from '../../types/formTypes';
import FieldTypeDropdown from './FieldTypeDropdown';

interface FieldHeaderProps {
	label: string;
	onLabelChange: (label: string) => void;
	fieldType?: FieldType;
	onFieldTypeChange?: (type: FieldType) => void;
}

const FieldHeader: React.FC<FieldHeaderProps> = ({
	label,
	onLabelChange,
	fieldType,
	onFieldTypeChange,
}) => {
	return (
		<div className="flex items-center gap-2">
			<Input
				value={label}
				onChange={(e) => onLabelChange(e.target.value)}
				className="flex-1 font-medium"
				placeholder="Frage"
				aria-label="Frage"
				data-testid="field-label-input"
			/>
			{fieldType && onFieldTypeChange && (
				<FieldTypeDropdown
					value={fieldType}
					onChange={onFieldTypeChange}
				/>
			)}
		</div>
	);
};

export default FieldHeader;
